"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdsFilePickerWidget = void 0;
var react_1 = __importDefault(require("react"));
var web_component_1 = require("./web-component");
var react_utils_1 = require("../utils/react-utils");
function PdsFilePickerWidget(props) {
    return (react_1.default.createElement(web_component_1.WebComponent, { tag: "pds-file-picker-widget", attributes: {
            name: react_utils_1.toAttribute(props.name),
            'data-label-text': react_utils_1.toAttribute(props.dataLabelText),
            'data-show-label': react_utils_1.toAttribute(props.dataShowLabel),
            'data-aria-label': react_utils_1.toAttribute(props.dataAriaLabel),
            'data-badge-text': react_utils_1.toAttribute(props.dataBadgeText),
            'data-tooltip-text': react_utils_1.toAttribute(props.dataTooltipText),
            'data-helper-text': react_utils_1.toAttribute(props.dataHelperText),
            'data-hide-unelevated-badge': react_utils_1.toAttribute(props.dataHideUnelevatedBadge),
            'data-disable-invalid-badge-elevation': react_utils_1.toAttribute(props.dataDisableInvalidBadgeElevation),
            'data-isrequired': react_utils_1.toAttribute(props.dataIsrequired),
            'data-use-alternate-color-scheme': react_utils_1.toAttribute(props.dataUseAlternateColorScheme),
            'data-customvalidate': react_utils_1.toAttribute(props.dataCustomvalidate),
            'data-show-selected-file': react_utils_1.toAttribute(props.dataShowSelectedFile),
            'data-button-text': react_utils_1.toAttribute(props.dataButtonText),
            'accept': react_utils_1.toAttribute(props.accept),
            'multiple': react_utils_1.toAttribute(props.multiple),
            'disabled': react_utils_1.toAttribute(props.disabled),
            class: react_utils_1.toAttribute(props.className)
        }, properties: {
            modelValue: props.modelValue
        }, listeners: {
            modelValueChange: function (event) {
                props.modelValueChange(event.target.modelValue);
            }
        } }));
}
exports.PdsFilePickerWidget = PdsFilePickerWidget;

//# sourceMappingURL=pds-file-picker-widget.js.map
